export default __webpack_public_path__ + "static/media/overlay.6278066c.svg";